/* eslint-disable max-lines-per-function */

import PodSource from "components/HomeVideoReviews/PodSource"

import { ComponentProps } from "."
import { Ul, Wrapper } from "./styled"

const HeaderPods = ({
  areReviewsLoading,
  avForums,
  avNirvana,
  avsForum,
  bluRay,
  bluRayAuthority,
  digitalBits,
  doBlu,
  hidefDigest,
  highDefDiscNews,
  homeTheaterForum,
  isCompact,
  left,
  onClear,
  onSetReview,
  theaterByte,
  whySoBlu
}: ComponentProps) => (
  <Wrapper>
    {left}

    <Ul $isCompact={isCompact} aria-label="Header Pods">
      <li aria-label="Blu-ray.com">
        <PodSource
          areReviewsLoading={areReviewsLoading}
          isCompact={isCompact}
          isCreated={bluRay.isCreated}
          isLoading={bluRay.isPreviewLoading}
          isValid={bluRay.isPreviewValid}
          label="Blu-ray.com"
          onClear={onClear}
          onSetReview={onSetReview}
          review={bluRay.review}
          serviceName="bluRay"
          text={bluRay.url}
        />
      </li>

      <li aria-label="AV Forums">
        <PodSource
          areReviewsLoading={areReviewsLoading}
          isCompact={isCompact}
          isCreated={avForums.isCreated}
          isLoading={avForums.isPreviewLoading}
          isValid={avForums.isPreviewValid}
          label="AV Forums"
          onClear={onClear}
          onSetReview={onSetReview}
          review={avForums.review}
          serviceName="avForums"
          text={avForums.url}
        />
      </li>

      <li aria-label="AV Nirvana">
        <PodSource
          areReviewsLoading={areReviewsLoading}
          isCompact={isCompact}
          isCreated={avNirvana.isCreated}
          isLoading={avNirvana.isPreviewLoading}
          isValid={avNirvana.isPreviewValid}
          label="AV Nirvana"
          onClear={onClear}
          onSetReview={onSetReview}
          review={avNirvana.review}
          serviceName="avNirvana"
          text={avNirvana.url}
        />
      </li>

      <li aria-label="AVS Forum">
        <PodSource
          areReviewsLoading={areReviewsLoading}
          isCompact={isCompact}
          isCreated={avsForum.isCreated}
          isLoading={avsForum.isPreviewLoading}
          isValid={avsForum.isPreviewValid}
          label="AVS Forum"
          onClear={onClear}
          onSetReview={onSetReview}
          review={avsForum.review}
          serviceName="avsForum"
          text={avsForum.url}
        />
      </li>

      <li aria-label="Blu-ray Authority">
        <PodSource
          areReviewsLoading={areReviewsLoading}
          isCompact={isCompact}
          isCreated={bluRayAuthority.isCreated}
          isLoading={bluRayAuthority.isPreviewLoading}
          isValid={bluRayAuthority.isPreviewValid}
          label="Blu-ray Authority"
          onClear={onClear}
          onSetReview={onSetReview}
          review={bluRayAuthority.review}
          serviceName="bluRayAuthority"
          text={bluRayAuthority.url}
        />
      </li>

      <li aria-label="Digital Bits">
        <PodSource
          areReviewsLoading={areReviewsLoading}
          isCompact={isCompact}
          isCreated={digitalBits.isCreated}
          isLoading={digitalBits.isPreviewLoading}
          isValid={digitalBits.isPreviewValid}
          label="Digital Bits"
          onClear={onClear}
          onSetReview={onSetReview}
          review={digitalBits.review}
          serviceName="digitalBits"
          text={digitalBits.url}
        />
      </li>

      <li aria-label="Do Blu">
        <PodSource
          areReviewsLoading={areReviewsLoading}
          isCompact={isCompact}
          isCreated={doBlu.isCreated}
          isLoading={doBlu.isPreviewLoading}
          isValid={doBlu.isPreviewValid}
          label="Do Blu"
          onClear={onClear}
          onSetReview={onSetReview}
          review={doBlu.review}
          serviceName="doBlu"
          text={doBlu.url}
        />
      </li>

      <li aria-label="Hi-Def Digest">
        <PodSource
          areReviewsLoading={areReviewsLoading}
          isCompact={isCompact}
          isCreated={hidefDigest.isCreated}
          isLoading={hidefDigest.isPreviewLoading}
          isValid={hidefDigest.isPreviewValid}
          label="Hi-Def Digest"
          onClear={onClear}
          onSetReview={onSetReview}
          review={hidefDigest.review}
          serviceName="hidefDigest"
          text={hidefDigest.url}
        />
      </li>

      <li aria-label="HighDefDiscNews.com">
        <PodSource
          areReviewsLoading={areReviewsLoading}
          isCompact={isCompact}
          isCreated={highDefDiscNews.isCreated}
          isLoading={highDefDiscNews.isPreviewLoading}
          isValid={highDefDiscNews.isPreviewValid}
          label="HighDefDiscNews.com"
          onClear={onClear}
          onSetReview={onSetReview}
          review={highDefDiscNews.review}
          serviceName="highDefDiscNews"
          text={highDefDiscNews.url}
        />
      </li>

      <li aria-label="Home Theater Forum">
        <PodSource
          areReviewsLoading={areReviewsLoading}
          isCompact={isCompact}
          isCreated={homeTheaterForum.isCreated}
          isLoading={homeTheaterForum.isPreviewLoading}
          isValid={homeTheaterForum.isPreviewValid}
          label="HT Forum"
          onClear={onClear}
          onSetReview={onSetReview}
          review={homeTheaterForum.review}
          serviceName="homeTheaterForum"
          text={homeTheaterForum.url}
        />
      </li>

      <li aria-label="Theater Byte">
        <PodSource
          areReviewsLoading={areReviewsLoading}
          isCompact={isCompact}
          isCreated={theaterByte.isCreated}
          isLoading={theaterByte.isPreviewLoading}
          isValid={theaterByte.isPreviewValid}
          label="Theater Byte"
          onClear={onClear}
          onSetReview={onSetReview}
          review={theaterByte.review}
          serviceName="theaterByte"
          text={theaterByte.url}
        />
      </li>

      <li aria-label="Why So Blu?">
        <PodSource
          areReviewsLoading={areReviewsLoading}
          isCompact={isCompact}
          isCreated={whySoBlu.isCreated}
          isLoading={whySoBlu.isPreviewLoading}
          isValid={whySoBlu.isPreviewValid}
          label="Why So Blu?"
          onClear={onClear}
          onSetReview={onSetReview}
          review={whySoBlu.review}
          serviceName="whySoBlu"
          text={whySoBlu.url}
        />
      </li>
    </Ul>
  </Wrapper>
)

export default HeaderPods
